import {TextField} from "@material-ui/core";
import {Box, IconButton, styled, Tooltip} from "@mui/material";
import i18n from "../translations/i18n";
import GTranslateIcon from "@mui/icons-material/GTranslate";
import {FLAGS} from "./LanguagesDropdown";
import React, {FC, useState} from "react";
import {useTranslation} from "react-i18next";
import {Languages} from "../constants/languages";
import {translateText} from "../services/translateService";
import {useSelector} from "../redux/store";
import {removeSuffix} from "../utils/functions";

const InputWrapper = styled('div')`
  position: relative;
  width: 100%;
`

const Flag = styled('div')`
  position: absolute;
  z-index: 5;
  top: 15px;
  right: 11px
`

type PropsType = {
  value: {[key: string]: string}
  lang: string
  onChange: (text: string, language: string) => void
  variant?: "filled" | "outlined" | "standard" | undefined
  label?: string
  placeholder?: string
}

const MultiLanguageInput: FC<PropsType> = ({
  value,
  lang,
  onChange,
  variant = 'outlined',
  label,
  placeholder
}) => {
  const { t } = useTranslation()
  const user = useSelector((state) => state.authReducer.user!)
  const [loading, setLoading] = useState(false)

  const namesLanguages: { [key: string]: any } = {
    [Languages.English]: t("LanguagesDropdown_English"),
    [Languages.Swedish]: t("LanguagesDropdown_Swedish"),
    [Languages.Danish]: t("LanguagesDropdown_Danish"),
    [Languages.German]: t("LanguagesDropdown_German"),
    [Languages.Spanish]: t('LanguagesDropdown_Spanish'),
    [Languages.French]: t("LanguagesDropdown_French"),
    [Languages.Norwegian]: t("LanguagesDropdown_Norwegian"),
    [Languages.Portuguese]: t("LanguagesDropdown_Portuguese"),
    [Languages.Ukrainian]: t("LanguagesDropdown_Ukrainian"),
  }

  const isTranslateDisabled = () => {
    return value && value[removeSuffix(i18n.language)] === ''
  }

  const handleTranslateText = (targetLanguage: string) => {
    setLoading(true)
    const data = {
      text: value[removeSuffix(i18n.language)],
      source_language_code: removeSuffix(i18n.language),
      target_language_code: targetLanguage
    }
    translateText(data, user!.token).then((response: any) => {
      if (response.translated_text) {
        onChange(response.translated_text, targetLanguage)
      }
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  return (
    <InputWrapper>
      <TextField
        disabled={loading}
        fullWidth
        value={value[lang] ? value[lang] : ''}
        label={label ? `${namesLanguages[lang]} ${t(label).toLowerCase()}` : ''}
        placeholder={placeholder}
        variant={variant}
        onChange={(e) => onChange(e.target.value, lang)}
      />
      <Box position={'absolute'} top={5} right={36}>
        <Tooltip title={`Translate automatically from ${namesLanguages[removeSuffix(i18n.language)]}`} placement={'top'} arrow>
          <IconButton
            color={'inherit'}
            disabled={isTranslateDisabled() || loading}
            onClick={() => handleTranslateText(lang)}
          >
            <GTranslateIcon/>
          </IconButton>
        </Tooltip>
      </Box>
      <Tooltip title={`This is ${namesLanguages[lang]} language`} placement={'top'} arrow>
        <Flag>
          {FLAGS[lang]}
        </Flag>
      </Tooltip>
    </InputWrapper>
  )
}

export default MultiLanguageInput